<template>
  <div id="proInfo">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/productList' }">产品列表</el-breadcrumb-item>
      <el-breadcrumb-item>基本信息</el-breadcrumb-item>
    </el-breadcrumb>
    <p class="title">基本信息</p>
    <div id="pro_info">
      <el-form ref="form" label-width="20%" id="form" :model="dataTable" :rules="dataVerification">
        <el-form-item label="产品类型：">
         <span>{{dataTable.open_product_type}}</span>
          <!--<el-input placeholder="请输入产品类型" v-model="dataTable.open_product_type" disabled></el-input>-->
        </el-form-item>
        <el-form-item label="产品名称：" prop="client_name">
          <el-input placeholder="请输入产品名称，2~50个汉字、英文" v-model.trim="dataTable.client_name" @input.native="changeRoute"></el-input>
        </el-form-item>
          <el-form-item label="支持系统：">
            <img style="width: 60px;" src="../../../../static/images/android.png" alt="安卓">
          </el-form-item>
          <el-form-item label="Client_ID：">
            <span>{{dataTable.client_id}}</span>
            <!--<el-input v-model="dataTable.client_id" disabled></el-input>-->
          </el-form-item>
          <el-form-item label="Client_sectet：">
            <span>{{dataTable.client_secret}}</span>
            <!--<el-input v-model="dataTable.client_secret" disabled></el-input>-->
          </el-form-item>
          <el-form-item label="U_center_Client_ID：">
            <span>{{dataTable.ucenter_client_id}}</span>
            <!--<el-input v-model="dataTable.ucenter_client_id" disabled></el-input>-->
          </el-form-item>
          <el-form-item label="U_center_Client_secret：">
            <span>{{dataTable.ucenter_client_secret}}</span>
            <!--<el-input v-model="dataTable.ucenter_client_secret" disabled></el-input>-->
          </el-form-item>
          <el-form-item label="产品简介：" prop="open_product_intro">
            <el-input type="textarea" placeholder="简单介绍您的产品, 20~500字符" :autosize="{ minRows: 4, maxRows: 9}" v-model.trim="dataTable.open_product_intro" @input.native="changeRoute"></el-input>
          </el-form-item>
        </el-form>
    </div>
    <el-button type="primary" class="intentSavebtn complete" size="mini" round @click="updatePro">完成</el-button>
  </div>
</template>
<script>
  import qs from 'qs'
  import {proInfoApi, updateClientApi,checkProApi} from '@/api/hardIndex.js'
  export default {
    data() {
      var checkChinese = (rule, value, callback) => {
        setTimeout(() => {
          var reg = new RegExp("^[\u4e00-\u9fa5a-zA-Z]+$");
          if (!reg.test(value)) {
//            this.$message.error('请输入正确的字典名，2~50个汉字')
            callback(new Error('请填写产品名称，并在2~50个汉字!'));
          } else {
            callback();
          }
        }, 100);
      }
      return {
        dataTable: {
          client_name: '',
          open_product_intro: '',
        },
        dataVerification: {
          client_name: [
            { required: true, message: '请输入产品名称', trigger: 'blur' },
            { min: 2, max: 50, message: '长度在 2 到 50 个汉字、英文', trigger: 'blur' },
            {validator: checkChinese, trigger: 'blur'}
          ],
          open_product_intro: [
            { required: true, message: '请输入产品简介', trigger: 'blur'},
            { min: 20, max: 500, message: '长度在 20 到 500 个字符', trigger: 'blur' }
          ],
        }
      }
    },
    created () {
      this.proInfo()
    },
    methods: {
      changeRoute () {
        this.$store.dispatch('changeR',false);
      },
      async proInfo () {
        let res = await proInfoApi(qs.stringify({'client_id': this.$route.query.client_id}))
        if (res.data.code == 200) {
          this.dataTable = res.data.data.data
        } else {
          this.$message.error('获取基本信息失败')
        }
      },
      async updatePro () {
        let regProductName=/[^\u4e00-\u9fa5A-Za-z]/g;
        this.$store.dispatch('changeR',true);//保存后改变可以跳转路由
        if (regProductName.test(this.dataTable.client_name ) ||this.dataTable.client_name == '' || this.dataTable.client_name.length < 2 || this.dataTable.client_name.length > 50) {
//          this.$message.error('请填写产品名称，并在2~50个汉字!')
          this.$root.scroll_top();
          return
        }
        if (this.dataTable.open_product_intro == '' || this.dataTable.open_product_intro.length < 20 || this.dataTable.open_product_intro.length > 500) {
//          this.$message.error('请填写产品简介，并在20~500个字符!')
          return
        }
        let da = await checkProApi(qs.stringify({'client_name': this.dataTable.client_name, 'client_id': this.dataTable.client_id}))
        if (da.data.code != 200) {
          this.$message({message: da.data.errors.data, type: 'error'})
          return
        }
        let res = await updateClientApi(qs.stringify(this.dataTable))
        if (res.data.code == 200) {
          this.$message.success('修改成功')
          this.$store.dispatch('changeClientName',this.dataTable.client_name)
          this.proInfo()
        } else {
          this.$message.error('修改失败')
        }
      }

    }
  }
</script>
<style  rel="stylesheet/scss" lang="scss">
  #proInfo{
    background:#fff;
    padding-bottom:20px;
    .title{
      height:64px;
      line-height:64px;
      padding-left:30px;
      font-size: 16px;
      color:#2e4d79;
      border-bottom:1px solid #f5f5f5;
      border-left:2px solid #010202;
    }
    #pro_info{
      padding:30px 30px 0 0;
      #form{
        .el-input__inner{
          width: 250px;
          height:28px;
          line-height: 28px;
          border-radius:14px;
        }
        .el-textarea__inner{
          width:80%;
          border-radius: 14px;
        }
      }
    }
    .complete{
      margin-left:45%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/hardware/pro/ProInfo.vue